import {
  Box,
  Divider,
  Flex,
  Grid,
  GridItem,
  Heading,
  Icon,
  SkeletonCircle,
  SkeletonText,
  Text,
  Image,
  Tag,
  TagLabel,
  Table,
  Tbody,
  TableContainer,
  Td,
  Th,
  Thead,
  Tr,
  TableCaption,
  Link,
  Show,
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Center,
  HStack,
  Button,
} from "@chakra-ui/react";
import { Component } from "react";
import { EstimateDetails } from "../../CommonProps";
import { InspectionService } from "../../Services/inspectionService";
import { IBodyshopService } from "../../UserService";
import {
  AiOutlineDownload,
  AiOutlineHome,
  AiOutlineMail,
  AiOutlineMobile,
  AiOutlinePhone,
  FaBan,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/all";
import { ReactSVG } from "react-svg";
import {
  Checklist,
  Fax,
  Pin,
  User,
  Vehicle,
  VehicleParts,
} from "../../shared/icons/customIcons";

export class InspectionViewer extends Component<any, any, any> {
  inspectionsService = new InspectionService();
  private ibsService = new IBodyshopService();
  logo = require("../../assets/images/svg/logo_full.svg").default;
  icon = require("../../assets/images/svg/icon_logo.svg").default;
  estimateId = "";
  inspection: any;

  constructor(props: any) {
    super(props);

    const urlSearchParams = new URLSearchParams(
      window.location.search.toLowerCase()
    );
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params["estimateid"]) {
      this.estimateId = params["estimateid"];
    }

    this.state = {
      inspection: "",
      loading: true,
      inspectionsChecklist: "",
      estimate: "",
      error: false,
      fileLink: "",
    };

    this.init();
  }

  async init() {
    this.ibsService.currentUser = JSON.parse(
      localStorage.getItem("currentUser") as any
    ) as any;

    if (this.estimateId) {
      this.getDetails();
    } else {
      if (!this.ibsService.currentUser) {
        this.ibsService.logout();
      } else {
        this.ibsService.loggedIn = true;
        if (this.ibsService.currentUser.user.external_id) {
          this.estimateId = this.ibsService.currentUser.user.external_id;
          this.getDetails();
        } else {
          this.setState({ loading: false });
          this.setState({ error: true });
        }
      }
    }
  }

  getDetails() {
    this.ibsService.getEstimateDetailsById(this.estimateId).then((res) => {
      if (res.ok) {
        res.json().then(async (data: EstimateDetails) => {
          this.setState({ estimate: data });
          this.estimateId = data.header.id;
          const inspection = await this.inspectionsService.getInspectionById(
            this.estimateId
          );
          if (
            inspection !== undefined &&
            Array.isArray(inspection) &&
            inspection.length > 0
          ) {
            this.inspection = inspection[0];
            this.setState({ inspection: this.inspection });
            this.getInspectionItems();
            this.checkInspection();
            this.setState({ loading: false });
          } else {
            this.setState({ loading: false });
            this.setState({ error: true });
          }
        });
      } else {
        this.setState({ loading: false });
        this.setState({ error: true });
      }
    });
  }

  async checkInspection() {
    const preChecks: any[] = [];
    this.state.estimate?.header?.attachmentLists?.forEach((attachment: any) => {
      if (attachment?.attachment?.storagePath.includes("Pre-repair")) {
        preChecks.push(attachment);
      }
    });
    if (preChecks.length > 0) {
      const file = await this.ibsService.getDocument(
        preChecks[preChecks.length - 1].id
      );
      this.setState({ fileLink: file });
    }
  }

  public async getInspectionItems() {
    const inspectionItems =
      await this.inspectionsService.getInspectionsChecks();

    if (Array.isArray(inspectionItems.vehicleChecks)) {
      inspectionItems.vehicleChecks = inspectionItems.vehicleChecks.filter(
        (checklistItem: any) => {
          if (
            this.state.inspection.inspectionChecks !== undefined &&
            Array.isArray(this.state.inspection.inspectionChecks)
          ) {
            const filled = this.state.inspection.inspectionChecks.find(
              (filled: any) => {
                if (filled.check_id === checklistItem.id) return filled;

                return undefined;
              }
            );
            if (filled) {
              checklistItem.value = filled.value;
              checklistItem.comment = filled.comment;
            }

            if (checklistItem.value !== undefined) {
              return checklistItem;
            }
          }

          return undefined;
        }
      );
    }

    this.setState({
      inspectionChecklist: inspectionItems.vehicleChecks,
    });
  }

  public buttons() {
    return (
      <HStack
        position={"sticky"}
        width="100%"
        justifyContent={"flex-end"}
        paddingRight={4}
        top={4}
      >
        <Button
          colorScheme="blue"
          leftIcon={<AiOutlineDownload />}
          disabled={this.state.fileLink === ""}
          as={Link}
          href={this.state.fileLink}
          target={"_blank"}
        >
          Download
        </Button>
        <Button
          as={Link}
          colorScheme="blue"
          variant="outline"
          leftIcon={<AiOutlineHome />}
          href="/"
        >
          Home
        </Button>
      </HStack>
    );
  }

  public renderChecklist() {
    if (
      this.state.inspectionChecklist !== undefined &&
      Array.isArray(this.state.inspectionChecklist)
    )
      return this.state.inspectionChecklist.map(function (item: any) {
        return (
          <Tr key={item.id}>
            <Td>
              <Text fontSize={"md"}>{item.label}</Text>
            </Td>
            <Td textAlign={"center"}>
              {item.value ? (
                item.value === "Yes" ? (
                  <Icon as={FaCheckCircle} w={7} h={7} color="green.500" />
                ) : item.value === "No" ? (
                  <Icon as={FaTimesCircle} w={7} h={7} color="red.500" />
                ) : (
                  <Icon as={FaBan} w={7} h={7} color="orange.500" />
                )
              ) : null}
            </Td>
            <Td>
              <Box
                bg={"gray.100"}
                borderRadius={8}
                boxShadow={2}
                p={2}
                minH={"40px"}
              >
                <Text fontSize={"sm"}>
                  {item.comment !== "" ? (
                    <Text fontSize={"sm"}>{item.comment}</Text>
                  ) : (
                    <Text fontSize={"sm"} opacity={0.5}>
                      No comment.
                    </Text>
                  )}
                </Text>
              </Box>
            </Td>
          </Tr>
        );
      });
    else {
      return <Tr></Tr>;
    }
  }

  public loader() {
    return (
      <Box
        padding="6"
        boxShadow="lg"
        bg="white"
        maxW={"1000px"}
        m="auto"
        marginY={8}
        border="1px"
        borderColor="gray.100"
        borderRadius={4}
      >
        <SkeletonCircle size="10" />
        <SkeletonText mt="4" noOfLines={8} spacing="4" />
        <SkeletonText mt="16" noOfLines={8} spacing="4" />
      </Box>
    );
  }

  public footer() {
    return (
      <Flex
        minH={"200px"}
        alignItems={"center"}
        maxW={"1000px"}
        marginX={"auto"}
        bg="gray.200"
      >
        <Grid
          templateColumns={["repeat(2, 1fr)", "repeat(3, 1fr)"]}
          w={["100%", "60%"]}
          gap={2}
          p={6}
        >
          <GridItem>
            <Link
              fontSize={"sm"}
              alignItems={"center"}
              display={"flex"}
              href="tel:+61481391467"
            >
              <Icon as={AiOutlineMobile} w={4} h={4} color={"blue.500"} />
              <Text fontSize={"sm"} marginLeft={1}>
                +61 481 391 467
              </Text>
            </Link>
          </GridItem>
          <GridItem>
            <Link
              fontSize={"sm"}
              alignItems={"center"}
              display={"flex"}
              href="tel:0733543711"
            >
              <Icon as={AiOutlinePhone} w={4} h={4} color={"blue.500"} />
              <Text fontSize={"sm"} marginLeft={1}>
                07 3354 3711
              </Text>
            </Link>
          </GridItem>
          <GridItem>
            <Link
              fontSize={"sm"}
              alignItems={"center"}
              display={"flex"}
              href="tel:0733542228"
            >
              <Icon as={Fax} w={4} h={4} color={"blue.500"} />
              <Text fontSize={"sm"} marginLeft={1}>
                07 3354 2228
              </Text>
            </Link>
          </GridItem>
          <GridItem>
            <Link
              fontSize={"sm"}
              alignItems={"center"}
              display={"flex"}
              href="https://goo.gl/maps/KAXhtVav8gCaXZci9"
              target={"_blank"}
            >
              <Icon as={Pin} w={4} h={4} color={"blue.500"} />
              <Text fontSize={"sm"} marginLeft={1}>
                268 South Pine Road, Enoggera, QLD 4051
              </Text>
            </Link>
          </GridItem>
          <GridItem>
            <Link
              fontSize={"sm"}
              alignItems={"center"}
              display={"flex"}
              href="mailto:hello@ﬂowautobody.com.au"
            >
              <Icon as={AiOutlineMail} w={4} h={4} color={"blue.500"} />
              <Text fontSize={"sm"} marginLeft={1}>
                hello@ﬂowautobody.com.au
              </Text>
            </Link>
          </GridItem>
          <GridItem>
            <Link
              fontSize={"sm"}
              alignItems={"center"}
              href="https://www.ﬂowautobody.com.au"
              target={"_blank"}
            >
              <Text fontSize={"sm"} fontWeight="bold">
                www.ﬂowautobody.com.au
              </Text>
            </Link>
          </GridItem>
        </Grid>
        <Box
          width={["100%", "40%"]}
          position={"relative"}
          height="inherit"
          minHeight={"inherit"}
          overflow="hidden"
        >
          <Box
            opacity={0.2}
            position={"absolute"}
            width="60%"
            top={"-20%"}
            right={"-20%"}
          >
            <ReactSVG src={this.icon} />
          </Box>
        </Box>
      </Flex>
    );
  }

  public error() {
    return (
      <Center
        boxShadow="lg"
        bg="white"
        maxW={"1000px"}
        marginX="auto"
        marginY={8}
        border="1px"
        borderColor="gray.100"
        borderRadius={4}
      >
        <Alert status="error" textAlign={"center"}>
          <AlertIcon />
          <AlertTitle>Ouch!!!</AlertTitle>
          <AlertDescription>
            We coldn't find your pre-inspection.
          </AlertDescription>
        </Alert>
      </Center>
    );
  }

  public inspectionView() {
    return (
      <Box>
        <Box
          padding="6"
          boxShadow="lg"
          bg="white"
          maxW={"1000px"}
          m="auto"
          marginY={8}
          border="1px"
          borderColor="gray.100"
          borderRadius={4}
        >
          <Box maxWidth={"400px"}>
            <ReactSVG src={this.logo} />
          </Box>
          <Heading as="h2" size="xl" mt={8} noOfLines={1}>
            Pre-Repair Inspection Report
          </Heading>
          <Divider marginY={8} opacity={0.2} />
          <Flex alignItems={"center"}>
            <Icon as={User} w={10} h={10} color={"blue.500"} />
            <Heading
              fontWeight={"500"}
              ml={2}
              size="lg"
              height={"100%"}
              color={"blue.500"}
            >
              Owner Details
            </Heading>
          </Flex>
          <Grid
            templateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
            gap={4}
            mt={6}
          >
            <GridItem>
              <Text>
                <b>Name:</b>{" "}
                {this.state.estimate?.header?.owner?.contactDetails
                  ?.displayName ?? ""}
              </Text>
            </GridItem>
            <GridItem>
              <Text>
                <b>Email:</b>{" "}
                {this.state.estimate?.header?.owner?.contactDetails
                  ?.emailAddress ?? ""}
              </Text>
            </GridItem>
            <GridItem>
              <Text>
                <b>Phone:</b>{" "}
                {this.state.estimate?.header?.owner?.contactDetails
                  ?.mobilePhone ?? ""}
              </Text>
            </GridItem>
            <GridItem>
              <Text>
                <b>Preferred Contact Method:</b>{" "}
                {this.state.estimate?.header?.owner?.contactDetails
                  ?.preferredContactMethod ?? ""}
              </Text>
            </GridItem>
          </Grid>
          <Divider marginY={8} opacity={0.2} />
          <Flex alignItems={"center"}>
            <Icon as={Vehicle} w={10} h={10} color={"blue.500"} />
            <Heading
              fontWeight={"500"}
              ml={2}
              size="lg"
              height={"100%"}
              color={"blue.500"}
            >
              Vehicle Details
            </Heading>
          </Flex>
          <Grid
            templateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
            gap={4}
            mt={6}
          >
            <GridItem>
              <Text>
                <b>Registration:</b>{" "}
                {this.state.estimate?.header?.vehicle?.registration ?? ""}
              </Text>
            </GridItem>
            <GridItem>
              <Text>
                <b>Vehicle:</b>{" "}
                {this.state.estimate?.header?.vehicle?.make &&
                this.state.estimate?.header?.vehicle?.model
                  ? this.state.estimate?.header?.vehicle?.make +
                    this.state.estimate?.header?.vehicle?.model
                  : ""}
              </Text>
            </GridItem>
            <GridItem>
              <Text>
                <b>Colour:</b>{" "}
                {this.state.estimate?.header?.vehicle?.colour ?? ""}
              </Text>
            </GridItem>
            <GridItem>
              <Text>
                <b>Paint Code: </b>{" "}
                {this.state.estimate?.header?.vehicle?.paintCode ?? ""}
              </Text>
            </GridItem>
            <GridItem>
              <Text>
                <b>Odometer: </b>{" "}
                {this.state.estimate?.header?.vehicle?.odometer ?? ""}
              </Text>
            </GridItem>
          </Grid>
          <Divider marginY={8} opacity={0.2} />
          <Flex alignItems={"center"}>
            <Icon as={VehicleParts} w={10} h={10} color={"blue.500"} />
            <Heading
              fontWeight={"500"}
              ml={2}
              size="lg"
              height={"100%"}
              color={"blue.500"}
            >
              Damage Information
            </Heading>
          </Flex>
          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(2, 1fr)",
            ]}
            gap={4}
            mt={6}
          >
            <GridItem>
              <Image
                maxWidth={"100%"}
                src={this.state.inspection?.inspection_image}
              />
            </GridItem>
            <GridItem>
              <Show above="sm">
                <Grid templateColumns="repeat(3, 1fr)" gap={2} p={4}>
                  {this.state.inspection?.inspectionMenu[0] && (
                    <GridItem>
                      <Heading size={"sm"} mb={4}>
                        Damages Areas
                      </Heading>
                    </GridItem>
                  )}
                  {this.state.inspection?.inspectionMenu[0] && (
                    <GridItem>
                      <Heading size={"sm"} mb={4}>
                        Severity
                      </Heading>
                    </GridItem>
                  )}
                  {(this.state.inspection?.interior_condition ||
                    this.state.inspection?.exterior_condition ||
                    this.state.inspection?.vehicle_condition) && (
                    <GridItem>
                      <Heading size={"sm"} mb={4}>
                        Car Condition
                      </Heading>
                    </GridItem>
                  )}
                </Grid>
              </Show>
              <Grid
                templateColumns={["repeat(2, 1fr)", "repeat(3, 1fr)"]}
                gap={2}
                bg={"gray.100"}
                borderRadius={8}
                boxShadow={2}
                p={4}
              >
                {this.state.inspection?.inspectionMenu[0] && (
                  <GridItem gap={2} display={"flex"} flexFlow={"column"}>
                    <Show below="md">
                      <Heading size={"sm"} mb={4}>
                        Damages Areas
                      </Heading>
                    </Show>
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.driver_front !==
                        "" && (
                        <Tag
                          size={"lg"}
                          variant="outline"
                          colorScheme="blue"
                          maxHeight={"32px"}
                          width={"fit-content"}
                        >
                          <TagLabel>Driver Front</TagLabel>
                        </Tag>
                      )}

                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]
                        ?.passenger_front !== "" && (
                        <Tag
                          size={"lg"}
                          variant="outline"
                          colorScheme="blue"
                          maxHeight={"32px"}
                          width={"fit-content"}
                        >
                          <TagLabel>Passenger Front</TagLabel>
                        </Tag>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.driver_side !==
                        "" && (
                        <Tag
                          size={"lg"}
                          variant="outline"
                          colorScheme="blue"
                          maxHeight={"32px"}
                          width={"fit-content"}
                        >
                          <TagLabel>Driver Side</TagLabel>
                        </Tag>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]
                        ?.passenger_side !== "" && (
                        <Tag
                          size={"lg"}
                          variant="outline"
                          colorScheme="blue"
                          maxHeight={"32px"}
                          width={"fit-content"}
                        >
                          <TagLabel>Passenger Side</TagLabel>
                        </Tag>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.driver_rear !==
                        "" && (
                        <Tag
                          size={"lg"}
                          variant="outline"
                          colorScheme="blue"
                          maxHeight={"32px"}
                          width={"fit-content"}
                        >
                          <TagLabel>Driver Rear</TagLabel>
                        </Tag>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]
                        ?.passenger_rear !== "" && (
                        <Tag
                          size={"lg"}
                          variant="outline"
                          colorScheme="blue"
                          maxHeight={"32px"}
                          width={"fit-content"}
                        >
                          <TagLabel>Passenger Rear</TagLabel>
                        </Tag>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.roof !== "" && (
                        <Tag
                          size={"lg"}
                          variant="outline"
                          colorScheme="blue"
                          maxHeight={"32px"}
                          width={"fit-content"}
                        >
                          <TagLabel>Roof</TagLabel>
                        </Tag>
                      )}
                  </GridItem>
                )}
                {this.state.inspection?.inspectionMenu[0] && (
                  <GridItem>
                    <Show below="md">
                      <Heading size={"sm"} mb={4}>
                        Severity
                      </Heading>
                    </Show>
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.driver_front !==
                        "" && (
                        <Text lineHeight={"36px"}>
                          {
                            this.state.inspection?.inspectionMenu[0]
                              ?.driver_front
                          }
                        </Text>
                      )}

                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]
                        ?.passenger_front !== "" && (
                        <Text lineHeight={"36px"}>
                          {
                            this.state.inspection?.inspectionMenu[0]
                              ?.passenger_front
                          }
                        </Text>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.driver_side !==
                        "" && (
                        <Text lineHeight={"36px"}>
                          {
                            this.state.inspection?.inspectionMenu[0]
                              ?.driver_side
                          }
                        </Text>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]
                        ?.passenger_side !== "" && (
                        <Text lineHeight={"36px"}>
                          {
                            this.state.inspection?.inspectionMenu[0]
                              ?.passenger_side
                          }
                        </Text>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.driver_rear !==
                        "" && (
                        <Text lineHeight={"36px"}>
                          {
                            this.state.inspection?.inspectionMenu[0]
                              ?.driver_rear
                          }
                        </Text>
                      )}
                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]
                        ?.passenger_rear !== "" && (
                        <Text lineHeight={"36px"}>
                          {
                            this.state.inspection?.inspectionMenu[0]
                              ?.passenger_rear
                          }
                        </Text>
                      )}

                    {this.state.inspection?.inspectionMenu[0] !== undefined &&
                      this.state.inspection?.inspectionMenu[0]?.roof !== "" && (
                        <Text lineHeight={"36px"}>
                          {this.state.inspection?.inspectionMenu[0]?.roof}
                        </Text>
                      )}
                  </GridItem>
                )}
                {(this.state.inspection?.interior_condition ||
                  this.state.inspection?.exterior_condition ||
                  this.state.inspection?.vehicle_condition) && (
                  <GridItem gap={2}>
                    <Show below="md">
                      <Heading size={"sm"} mb={4}>
                        Car Condition
                      </Heading>
                    </Show>
                    {this.state.inspection?.interior_condition && (
                      <Text
                        lineHeight={"36px"}
                        display={"flex"}
                        alignItems={"center"}
                      >
                        Interior:{" "}
                        <Tag
                          variant="solid"
                          height={"fit-content"}
                          m={"auto"}
                          colorScheme="blue"
                          size={"md"}
                        >
                          <TagLabel>
                            {this.state.inspection?.interior_condition}
                          </TagLabel>
                        </Tag>
                      </Text>
                    )}
                    {this.state.inspection?.exterior_condition && (
                      <Text
                        lineHeight={"36px"}
                        display={"flex"}
                        alignItems={"center"}
                      >
                        Exterior:{" "}
                        <Tag
                          variant="solid"
                          height={"fit-content"}
                          m={"auto"}
                          colorScheme="blue"
                          size={"md"}
                        >
                          <TagLabel>
                            {this.state.inspection?.exterior_condition}
                          </TagLabel>
                        </Tag>
                      </Text>
                    )}
                    {this.state.inspection?.vehicle_condition && (
                      <Text
                        lineHeight={"36px"}
                        display={"flex"}
                        alignItems={"center"}
                      >
                        General:{" "}
                        <Tag
                          variant="solid"
                          height={"fit-content"}
                          m={"auto"}
                          colorScheme="blue"
                          size={"md"}
                        >
                          <TagLabel>
                            {this.state.inspection?.vehicle_condition}
                          </TagLabel>
                        </Tag>
                      </Text>
                    )}
                  </GridItem>
                )}
              </Grid>
              <Heading size={"sm"} marginY={4}>
                Vehicle Comments
              </Heading>
              <Grid mt={4}>
                <GridItem
                  gap={2}
                  bg={"gray.100"}
                  borderRadius={8}
                  boxShadow={2}
                  minHeight={"100px"}
                  p={4}
                >
                  {this.state.inspection?.vehicle_comments
                    ? this.state.inspection?.vehicle_comments
                    : "No comments added"}
                </GridItem>
              </Grid>
              <Heading size={"sm"} marginY={4}>
                Customer Signature
              </Heading>
              <Grid mt={4}>
                {/* <GridItem
                  gap={2}
                  bg={"gray.100"}
                  borderRadius={8}
                  boxShadow={2}
                  minHeight={"100px"}
                  p={4}
                >
                  {this.state.inspection?.other
                    ? this.state.inspection?.other
                    : "No comments added"}
                </GridItem> */}
                <GridItem>
                  <Image
                    maxWidth={"100%"}
                    src={this.state.inspection?.signature_url}
                  />
                </GridItem>
              </Grid>
            </GridItem>
          </Grid>
          {this.footer()}
        </Box>
      </Box>
    );
  }

  renderChecklistPage() {
    return (
      <Box
        bg="white"
        maxW={"1000px"}
        marginX="auto"
        marginTop={8}
        border="1px"
        borderColor="gray.100"
        borderRadius={4}
        boxShadow="lg"
        marginBottom={6}
      >
        <Box padding={6}>
          <Flex alignItems={"center"}>
            <Icon as={Checklist} w={10} h={10} color={"blue.500"} />
            <Heading
              fontWeight={"500"}
              ml={2}
              size="lg"
              height={"100%"}
              color={"blue.500"}
            >
              Vehicle Checklist
            </Heading>
          </Flex>
          <TableContainer mt={4}>
            <Table variant="simple" size="sm">
              <Thead>
                <Tr>
                  <Th>
                    <Text>Title:</Text>
                  </Th>
                  <Th maxW={"80px"} textAlign={"center"}>
                    <Text>Status:</Text>
                  </Th>
                  <Th minW={"250px"}>
                    <Text>Comments:</Text>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>{this.renderChecklist()}</Tbody>
              <TableCaption>
                <Grid templateColumns="repeat(3, 1fr)" gap={4}>
                  <GridItem>
                    <Flex gap={2} alignItems={"center"}>
                      <Icon as={FaCheckCircle} w={8} h={8} color="green.500" />
                      Working
                    </Flex>
                  </GridItem>
                  <GridItem>
                    <Flex gap={2} alignItems={"center"}>
                      <Icon as={FaTimesCircle} w={8} h={8} color="red.500" />{" "}
                      Not Working
                    </Flex>
                  </GridItem>
                  <GridItem>
                    <Flex gap={2} alignItems={"center"}>
                      <Icon as={FaBan} w={8} h={8} color="orange.500" /> Not
                      Applicable
                    </Flex>
                  </GridItem>
                </Grid>
              </TableCaption>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    );
  }

  public render() {
    return (
      <div>
        {!this.state.loading && this.buttons()}
        {this.state.loading
          ? this.loader()
          : !this.state.error
          ? this.inspectionView()
          : this.error()}
      </div>
    );
  }
}

export default InspectionViewer;
